import { canv } from "@/canv/global.js";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import type { mindMapWidget } from "@/elements/mindMap/mindMap";
import { selectionManager } from "@/tools/cursorTool";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmDelete extends wmBase {
    build() {
        return `
            <div class="wm_delete">
                <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <clipPath id="a">
                        <path d="m0 0h20v20h-20z"/>
                    </clipPath>
                        <g clip-path="url(#a)" stroke="#2c2d32" stroke-width="1.3">
                            <path d="m4.71246 18.1059-1.34467-12.62499c-.06293-.59085.40018-1.10591.99438-1.10591h11.27563c.5942 0 1.0573.51506.9944 1.10591l-1.3447 12.62499c-.0541.5084-.4831.8941-.9943.8941h-8.58636c-.51129 0-.94023-.3857-.99438-.8941z"/>
                            <g stroke-linecap="round">
                                <path d="m1 4.375h18"/>
                                <path d="m7.75 8.875v5.625"/>
                                <path d="m12.25 8.875v5.625"/>
                            </g>
                            <path d="m6.39708 1.68377c.13611-.40834.51825-.68377.94868-.68377h5.30844c.4305 0 .8126.27543.9487.68377l.8971 2.69123h-9z"/>
                        </g>
                </svg>
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_delete");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = (): void => {
        const selectedEntities = canv.canvasController.selected;

        function isMindMapWidget(obj: ExtendsOfElementBase): obj is mindMapWidget {
            return obj?.constructorName === "mindMap" && "deleteSelectedNodes" in obj;
        }

        // кейс, когда в mindMap нужно удалить не все, а только отдельно выбранные узлы
        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
            if (child && isMindMapWidget(child) && child.selected.length !== 0) {
                child.deleteSelectedNodes();
                return;
            }
        }

        canv.eventManager.openRecord();
        for (const entity of selectedEntities) {
            canv.canvasController.deleteProcessor(entity);
        }
        canv.eventManager.closeRecord();

        selectionManager.clearSelected();
        canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
    };
}
